import { render, staticRenderFns } from "./DetailSearchItem.vue?vue&type=template&id=19bc01f7&scoped=true"
import script from "./DetailSearchItem.vue?vue&type=script&lang=js"
export * from "./DetailSearchItem.vue?vue&type=script&lang=js"
import style0 from "./DetailSearchItem.vue?vue&type=style&index=0&id=19bc01f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc01f7",
  null
  
)

export default component.exports